import { useTranslation } from 'react-i18next';

export default function ReceiptDeliveryNotFoundPage() {
  const { t } = useTranslation();

  const textClass = 'text-base max-w-[400px]';

  return (
    <div className="border-neutral-5 shadow-md-8 mx-auto mt-40 flex w-fit flex-col justify-center gap-4 rounded-md border bg-white p-5">
      <h2 className="typ-headline-md text-blue-110 flex w-full justify-center">
        {t('common.receipt.deliveryNotFound.title')}
      </h2>
      <p className={textClass}>
        {t('common.receipt.deliveryNotFound.explanation')}
      </p>
      <p className={textClass}>
        {t('common.receipt.deliveryNotFound.contact')}
      </p>
      <p className={`${textClass} mt-2`}>
        {t('common.receipt.deliveryNotFound.email')}
        <br />
        {t('common.receipt.deliveryNotFound.phone')}
      </p>
    </div>
  );
}
